import PlaceIcon from '@mui/icons-material/Place';
import { useState } from "react";
import {  Modal } from "react-bootstrap";
import { useLazyGetSelectedOrderDetailsQuery } from "../../../features/Dispatch/DispatchSlice";
import Button from '../../designSystem/Button/Button';

const ShowMapModal = ({ divisionId, orderId, showTextButton }) => {
    const [showModal, setShowModal] = useState(false);
    const [getDetails] = useLazyGetSelectedOrderDetailsQuery();

    const openMap = async (mode) => {
        try {
            const order = await getDetails({ divisionId, orderId });
            if (!order) return;

            const fromLocation = encodeURIComponent(JSON.stringify({
                street: order?.data?.data?.pickupStreetName || "",
                city: order?.data?.data?.pickupCity || "",
                province: order?.data?.data?.pickupProvince || "",
                country: order?.data?.data?.pickupCountry || "",
                zipcode: order?.data?.data?.pickupPostalCode || "",
            }));

            const toLocation = encodeURIComponent(JSON.stringify({
                street: order?.data?.data?.dropoffStreetName || "",
                city: order?.data?.data?.dropoffCity || "",
                province: order?.data?.data?.dropoffProvince || "",
                country: order?.data?.data?.dropoffCountry || "",
                zipcode: order?.data?.data?.dropoffPostalCode || "",
            }));

            const mapUrl = `/map?fromLocation=${fromLocation}&toLocation=${toLocation}&mode=${mode}`;
            window.open(mapUrl, '_blank');
        } catch (error) {
            console.error("Error fetching order details:", error);
        }
    };

    return (
        <>
            {showTextButton ? <Button fullWidth={false} size='md' variant='outline-primary' onClick={() => setShowModal(true)}>Map</Button> : <Button style={{height:"40px",width:"40px"}} fullWidth={false} variant='outline-success' size="sm" onClick={() => setShowModal(true)}>
                <PlaceIcon />
            </Button>}
            <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Choose Map View</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Select which location(s) to view:</p>
                    <div className='d-flex gap-2 mb-2'>
                        <Button
                            variant="primary"
                            className="w-50"
                            onClick={() => {
                                openMap("from");
                                setShowModal(false);
                            }}
                        >
                            Show From Location
                        </Button>
                        <Button
                            className="w-50"
                            variant="primary"
                            onClick={() => {
                                openMap("to");
                                setShowModal(false);
                            }}
                        >
                            Show To Location
                        </Button>
                    </div>
                    <Button
                        variant="success"
                        className="w-100"
                        onClick={() => {
                            openMap("both");
                            setShowModal(false);
                        }}
                    >
                        Show Both Locations
                    </Button>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default ShowMapModal;